import { Image } from 'react-native';
import { useSelector } from 'react-redux';

import { getBonusBannerImageByLanguage } from '../../../../assets/buttonsByLanguage';
import Centered from '../../../../shared/Centered';
import { RootState } from '../../../../store';

interface BGLogoProps {
	isSmall: boolean;
}

const BGLogo = ({ isSmall }: BGLogoProps) => {
	const langCode = useSelector((s: RootState) => s.i18n?.langCode ?? 'en');

	return (
		<Centered
			style={{
				width: '100%',
				position: 'absolute',
				left: 0,
				right: 0,
				top: isSmall ? -20 : -18,
				height: 1,
			}}
		>
			<Image
				source={getBonusBannerImageByLanguage(langCode)}
				resizeMode='contain'
				style={{
					width: isSmall ? '100%' : '70%',
					aspectRatio: 3.33,
					transform: [{ scale: isSmall ? 1 : 0.8 }],
				}}
			/>
		</Centered>
	);
};

export default BGLogo;
